import { Routes, Route } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Dashboard from "@/components/Dashboard";
import AccountsView from "@/components/AccountsView";
import PipelineView from "@/components/PipelineView";
import ContentView from "@/components/ContentView";
import AdvisorView from "@/components/AdvisorView";
import GoalsView from "@/components/GoalsView";
import TeamView from "@/components/TeamView";
import MarketView from "@/components/MarketView";
import CampaignsView from "@/components/CampaignsView";
import InstanceSwitcher from "@/components/InstanceSwitcher";

// Collapsible left rail listing the user's workspaces.
export const WorkspacePanel = ({ open, userId, currentInstance, onInstanceChange }) => (
  <AnimatePresence>
    {open && userId && userId !== "new" && (
      <motion.aside initial={{ width: 0, opacity: 0 }} animate={{ width: 280, opacity: 1 }} exit={{ width: 0, opacity: 0 }} transition={{ duration: 0.2 }}
        className="border-r border-white/5 bg-black/40 flex-shrink-0 overflow-hidden">
        <div className="p-4 h-[calc(100vh-120px)] overflow-y-auto">
          <div className="mb-4">
            <h3 className="text-xs tracking-wider text-gray-500 font-semibold">Business Initiatives</h3>
            <p className="text-[10px] text-gray-600 mt-1">Each workspace is a separate business</p>
          </div>
          <InstanceSwitcher userId={userId} currentInstance={currentInstance} onInstanceChange={onInstanceChange} />
        </div>
      </motion.aside>
    )}
  </AnimatePresence>
);

// Section routes under /dashboard/:userId. Stream state lives in CommandModule so it survives navigation.
export const AppRoutes = ({ userId, currentInstance, stream, onOpenTargeting }) => (
  <Routes>
    <Route index element={<Dashboard {...stream} currentInstance={currentInstance} onOpenTargeting={onOpenTargeting} />} />
    <Route path="accounts" element={<AccountsView currentInstance={currentInstance} />} />
    <Route path="market" element={<MarketView />} />
    <Route path="pipeline" element={<PipelineView currentInstance={currentInstance} />} />
    <Route path="content" element={<ContentView currentInstance={currentInstance} />} />
    <Route path="advisor" element={<AdvisorView currentInstance={currentInstance} />} />
    <Route path="campaigns" element={<CampaignsView userId={userId} />} />
    <Route path="goals" element={<GoalsView currentInstance={currentInstance} />} />
    <Route path="team" element={<TeamView currentInstance={currentInstance} />} />
  </Routes>
);
